import React, { useState } from "react";
import "./Loan.css";
import LoanApplicationForm from "./LoanApplicationForm";
import PartneredBanks from "./PartneredBanks";

const Loan = () => {
  const [showForm, setShowForm] = useState(false);

  const handleOpenForm = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="loan-position-wrapper">
      <div className="loan-container">
        <h1 className="loan-page-heading">Education Loans</h1>

        {/* Box 1 – Unsecured Loan Table */}
        <div className="loan-box">
          <h2>🎓 Post-Graduation Courses – Unsecured Loan</h2>

          <div className="table-wrapper">
            <table className="loan-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Student (Applicant)</th>
                  <th>Self-Employed Guarantor</th>
                  <th>Salaried Guarantor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Documents Required</td>
                  <td>
                    10th, 12th, Graduation marksheets,
                    <br />
                    Degree certificate, PTE score
                  </td>
                  <td>
                    KYC<br />
                    3 years ITR with computation<br />
                    12-month bank statement (saving + current)<br />
                    Business Registration<br />
                    GST Registration<br />
                    Latest Electricity Bill
                  </td>
                  <td>
                    KYC<br />
                    3 salary slips<br />
                    Form 16 or 2-year income proof<br />
                    Last 6-month bank statement<br />
                    Latest Electricity Bill
                  </td>
                </tr>
                <tr className="alt-row">
                  <td>Electricity Bill</td>
                  <td>Required</td>
                  <td>Required</td>
                  <td>Required</td>
                </tr>
                <tr>
                  <td>Co-applicant (2nd)</td>
                  <td>Same income documents as 1st co-applicant</td>
                  <td>Same as above</td>
                  <td>Same as above</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="loan-apply-btn-wrapper">
            <button className="loan-apply-btn" onClick={handleOpenForm}>Apply Now</button>
          </div>
        </div>

        {/* Box 2 – Secured Loan + Rates */}
        <div className="loan-box">
          <h3>🎓 For Graduation Courses (Secured Loan)</h3>
          <p>
            <strong>Security Required:</strong> Only approved property accepted as
            collateral.
          </p>
          <p>
            Applicant & Guarantor must provide standard KYC and income proof.
          </p>

          <h3>📊 Loan Terms & Rates</h3>

          <div className="table-wrapper">
            <table className="loan-table">
              <thead>
                <tr>
                  <th>Loan Type</th>
                  <th>Interest Rate Range</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Secured / Salaried Guarantor</td>
                  <td>10.75% to 11.5%</td>
                </tr>
                <tr className="alt-row">
                  <td>Unsecured Loan</td>
                  <td>12% to 13.5%</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="fee-info">
            <strong>Processing Fee:</strong> 1% to 1.5% (for all Bank/NBFC partners)
          </p>

          <div className="loan-apply-btn-wrapper">
            <button className="loan-apply-btn" onClick={handleOpenForm}>Apply Now</button>
          </div>
        </div>
      <PartneredBanks />
        {showForm && <LoanApplicationForm onClose={handleCloseForm} />}
      </div>
    </div>
  );
};

export default Loan;
